import React, { useEffect, useState } from 'react'
import { useAll_deptQuery, useUser_updateQuery } from '../../store/ReactWebSiteApi';
import { Space, Table } from 'antd';
import DeptAdd from './DeptAdd';
import DeptEdit from './DeptEdit';
import DeptDel from './DeptDel';

function DeptList() {
    const [list,setList] = useState([]);
        const {data, isSuccess} = useAll_deptQuery({
            e_id:localStorage.getItem('e_id'),
            ed_state:'2'
        });
        useEffect(() => {
            if(isSuccess){
                if(data.Status==='success'){
                    const newArr = data.Result.children.map((item) => {
                        const {title,key,}=item;
                        return item = {title,key}
                    })  
                    setList(newArr)                    
                }else{
                    setList(['暂无部门'])
                }
            }
        },[data, isSuccess])
        const columns = [    
            {
                key: 'type',
                title: '部门名称',
                dataIndex: 'title',
            },            
            {
                key: 'key',
                title: '部门编号',
                dataIndex: 'key',
            },            
            {
                key: 'action',
                width:'20%',
                title: '操作',
                render: (_, record) => {                
                    return <>
                        <Space>                        
                            <DeptEdit ed_id={record.key}/>
                            <DeptDel ed_id={record.key}/>
                        </Space>
                    </>
                }
            },
        ]
    //获取操作员数据
    
    const [info, setInfo] = useState({
        eu_e_id:localStorage.getItem('e_id'),  
        eu_id: '',  
        eu_name: '',
        eu_ba_phone:'',
        eu_uid: localStorage.getItem('eu_id'),
        eu_uname: localStorage.getItem('eu_name'),
        parent_dept_id: '',
        eu_station_id:'',
    });   
    const {data:dataUser,isSuccess:isSuccessUser} = useUser_updateQuery({eu_id:localStorage.getItem('eu_id')})
    useEffect(() => {
        if(isSuccessUser){
            if(dataUser.Status==='success'){               
                setInfo(prevState => ({
                    ...prevState,
                    eu_name: dataUser.Result.eu_name,
                    eu_ba_phone: dataUser.Result.eu_ba_phone,
                    eu_role: dataUser.Result.eu_role,
                    eu_dept_id: dataUser.Result.eu_dept_id,
                    eu_show_authority: dataUser.Result.eu_show_authority,
                    parent_dept_id: dataUser.Result.ed_id,
                    eu_station_id: dataUser.Result.eu_station_id,
                    eu_station_name: dataUser.Result.eu_station_name,
                }))
                    
            }
        }
    },[dataUser,isSuccessUser])
    return (
        <>
            <div style={{marginTop:"20px"}}>
                {info.eu_name && <DeptAdd userInfo={info}/>}
            </div>
            <Table
                columns={columns}
                dataSource={list}
                pagination={{
                    defaultPageSize:20,
                }}
            />
        </>
    )
}

export default DeptList